<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  mounted() {
    console.log(this.$store.state.user.did);
    if (
      this.$store.state.user.did === "" ||
      this.$store.state.user.did === undefined
    ) {
      this.$store.dispatch("user/refreshDID");
    }
  },
};
</script>
<style lang="scss">
* {
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
}
body {
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.65);
  font-size: 14px;
  line-height: 1.5;
}
div {
  user-select: none;
  box-sizing: border-box;
}
img {
  vertical-align: middle;
  border-style: none;
}
.breadcrumb {
  width: 1100px;
  margin: 0 auto;
  margin-top: 30px;
}
.el-message {
  top: 140px !important;
}
</style>
